import type { SxProps, Theme } from '@mui/material/styles';

export const chipListSx: SxProps<Theme> = {
  m: 0,
  mt: 1,
  p: 0,
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
};
